import { cn, formatCurrency } from '@/shared/lib'

const LIKE_ICON = `
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 20C9.5 17.8333 4.30001 13 3.50001 11C2.50001 8.5 3.23496 6.1767 5.00001 5C6.5 3.99999 9.99999 3.49999 12 6.99999C14 3.49999 17.5 3.99999 19 5C20.765 6.1767 21.5 8.5 20.5 11C19.7 13 14.5 17.8333 12 20Z" fill="#F04459" stroke="#F04459" stroke-linecap="square"/>
  </svg>
`

export const getContent = ({
  hasLike,
  hasViewed,
  fee,
  sameGpsCnt,
}: {
  hasLike: boolean
  hasViewed: boolean
  fee: number
  sameGpsCnt: number
}) => {
  const hasCount = sameGpsCnt > 1

  return `
      <div class="${cn('room-overlay', {
        'has-viewed': hasViewed,
      })}">
        ${hasLike ? LIKE_ICON : ''}
        <strong class="price">${formatCurrency(fee)}원</strong>
        ${
          hasCount
            ? `
          <span>외</span>
          <span class="count">${sameGpsCnt - 1}개</span>`
            : ''
        }
      </div>
    `
}
